import RecommendationTemplateDialog from './RecommendationTemplateDialog';

export { RecommendationTemplateDialog };
export default RecommendationTemplateDialog;
